const getQueryParam = (location, param) => {
	if (location) {
		const searchParams = new URLSearchParams(location.search);
		return searchParams.get(param);
	}
};

export default getQueryParam;
